import React from 'react';
import PortfolioItem from './PortfolioItem';
import Footer from './Footer';

const Portfolio = () => {
  const projects = [
    {
      name: 'Project 1',
      description: 'Description for project 1',
      mainImage: require('../assets/images/webpages/projekt-strony-internetowej-poznan-blobtech-identyfikacja-wizualna.png'),
      gallery: [
        require('../assets/images/webpages/projekt-identyfikacji-wizualnej-poznan-blobtech-no.png'),
        require('../assets/images/webpages/projekt-strony-internetowej-poznan-blobtech-identyfikacja-wizualna-mobilna.png'),
      ],
      link: 'https://project1-link.com',
    },
    {
      name: 'Project 2',
      description: 'Description for project 2',
      mainImage: 'path/to/project2-mainImage.jpg',
      gallery: [
        'path/to/project2-image1.jpg',
        'path/to/project2-image2.jpg',
      ],
      link: 'https://project2-link.com',
    },
    // Add more projects as needed
  ];

  return (
    <div className="portfolio">
       <div className="portfolio-header">
      <h1>PROJEKTOWANIE STRON INTERNETOWYCH I APLIKACJI MOBILNYCH</h1>
      <p>Projektowanie i programowanie stron internetowych dla firm i instytucji kultury. Tworzymy minimalistyczne wizytówki firmy w sieci, a także skomplikowane aplikacje, czy gry multimedialne na dotykowe ekrany. Współpracujemy również z software house'ami w zakresie UX i warstwie wizualnej projektów.</p></div>
      <div className="portfolio-grid">
        {projects.map((project, index) => (
          <PortfolioItem key={index} project={project} />
        ))}
      </div>
      <Footer /> 
    </div>
  );
};

export default Portfolio;
